import { BUSCAR_AGENDAMENTO_VIAGEM } from '../../actions/types'

const initialState = undefined;

const estadoInicial = {
  veiculo: {}
}

export default function reducerAgendamentoViagem (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_AGENDAMENTO_VIAGEM: {
      const agendamneto = action.payload.data;

      if (agendamneto) {
        return agendamneto
      }
      return estadoInicial
    }

    default: {
      return state
    }
  }
}
